import { none } from '../constants/levels'

const getPreferredLevelType = (levelPreference, hitLevels) => {
  if (levelPreference !== none && !hitLevels.length) {
    return none
  }
  return levelPreference
}

export default getPreferredLevelType
